import React, { useCallback, useEffect, useState } from "react";
import {
  Toast,
  Userlogin,
  formatRupee,
  formateNumberStNdRd,
  handleGetApiGF,
  handlePostApiGF,
} from "../Utils/general-function";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../Header";
import Loader from "../Utils/Loader";
import Search from "../Search";
import RemainingPageTitle from "../Utils/RemainingPageTitle";
import NoCars from "../Utils/NoCars";
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollButton from "../Utils/scrollbutton";
import { useCustomerCarContext } from "../Contexts/CustomerCarListContext";

// advance filter
import Select from "react-select";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import blackheart from "../../src_img/blackheart.png";
import redheart from "../../src_img/redheart.png";
import { FaRegHeart } from "react-icons/fa";

function CustomerCarList() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const {
    carState,
    setCarState,
    searchContxt,
    setSearchContxt,
    resultsContxt,
    setResultsContxt,
    pageIndexContxt,
    setPageIndexContxt,
    UserloggedContxt,
    setUserloggedContxt,
  } = useCustomerCarContext();

  const { originalList, showList, pageIndex, searchText } = carState;

  let location = useLocation();
  const { carcount } = location?.state || {}; // from parent to store in locla storage

  // in devlop
  const [Companylist, setCompanylist] = useState([]);
  const [ModeList, setModeList] = useState([]);
  const [States, setStates] = useState([]);
  const [Cities, setCities] = useState([]);
  const [Fuelist, setFuelist] = useState([]);
  const [Gearlist, setGearlist] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [ownerlist] = useState([
    { Text: "1", Value: 1 },
    { Text: "2", Value: 2 },
    { Text: "3", Value: 3 },
    { Text: "4", Value: 4 },
    { Text: "5", Value: 5 },
  ]);
  const [allWishlists, setAllWishlist] = useState(new Set());

  const fetchCars = async ({ index = 1, isLoadMore = false }) => {
    try {
      setLoading(true);
      setHasMore(true);

      // setCarState((prev) => ({ ...prev, hasMore: true }));
      const {
        state,
        city,
        compid,
        modelid,
        fuel,
        ModelYear,
        Pricerange,
        KMange,
        vehicle,
        Gear,
        owner,
      } = searchContxt;
      // const { pageIndex } = carState;
      let obj = {
        nState: state?.Text || null,
        nCity: city?.Text || "",
        companyid: compid?.Value || "",
        carmodelid: modelid?.Value || "",
        lowerprice: Pricerange[0],
        upperprice: Pricerange[1],
        kmbelow: KMange[0],
        kmupper: KMange[1],
        modelyearstart: ModelYear[0],
        modelyear: ModelYear[1],
        fueltypeid: fuel?.Value || "",
        pageindex: index,
        Gearid: Gear?.Value || "",
        vehicleid: "",
        owner: owner?.Value || "",
      };
      const res = await handlePostApiGF({
        url: `/api/CarthiClientSellInquiry/CarthiClientSellcarlist1`,
        obj,
      });

      if (!res?.succ) {
        if (res?.msg === "Data not available") {
          // setCarState((prev) => ({ ...prev, hasMore: false }));
          if (!isLoadMore) {
            // on search btn etc no data then clear previous data
            setResultsContxt([]);
          }
          setHasMore(false);
          // setCarState((prev) => ({ ...prev, hasMore: false }));
        } else {
          Toast(false, "", res?.msg);
        }
        setLoading(false);
        return;
      }

      const newData = res.data?.Data || [];
      console.log("newData", newData);

      if (isLoadMore) {
        setResultsContxt([...resultsContxt, ...newData]);
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });

        setResultsContxt(newData || []);
      }
      setLoading(false);
    } catch (error) {
      console.log("Exception found", error);
      setLoading(false);
      // setCarState((prev) => ({ ...prev, hasMore: false }));
      setHasMore(false);
    }
  };

  const loadMoreCars = () => {
    const nextIndex = pageIndexContxt + 1;
    setPageIndexContxt((prev) => nextIndex);
    fetchCars({ index: nextIndex, isLoadMore: true });
  };
  const onSubmitSearch = () => {
    const nextIndex = 1;
    setPageIndexContxt(nextIndex);
    fetchCars({ index: nextIndex });
  };

  const fetchState = () => {
    const res = handleGetApiGF({
      url: "/api/Common/statenamedata?countryid=1",
    });
    return res;
  };

  const fetchCompany = () => {
    const res = handleGetApiGF({
      url: "/api/Common/companydata",
    });
    return res;
  };
  const fetchFuel = () => {
    const res = handleGetApiGF({
      url: "/api/Common/Fueldata",
    });
    return res;
  };
  const fetchGear = () => {
    const res = handleGetApiGF({
      url: "/api/Common/Geardata",
    });
    return res;
  };
  const fetchCity = ({ stateid }) => {
    const res = handleGetApiGF({
      url: "/api/Common/citynamedata?countryid=1&stateid=" + stateid,
    });
    return res;
  };
  const fetchModel = ({ companyid }) => {
    const res = handleGetApiGF({
      url: "/api/Common/activemodel/" + companyid,
    });
    return res;
  };
  const fetchAllWishlist = async () => {
    const res = await handleGetApiGF({
      url:
        "/api/DealerFavouriteVehicle/AllFavouritecars?dealerrandno=" +
        localStorage.getItem("Ca1itd"),
    });
    if (!res.succ) {
      Toast(false, "", "Something went wrong");
      return;
    }
    return res?.data?.Data || [];
  };
  const fetchPromiseAll = async () => {
    const [state, company, fuel, gear, city, models, allWishlist] =
      await Promise.all([
        fetchState(),
        fetchCompany(),
        fetchFuel(),
        fetchGear(),
        fetchCity({ stateid: searchContxt?.state?.Value }),
        searchContxt?.compid?.Value &&
          fetchModel({ companyid: searchContxt?.compid?.Value }),
        fetchAllWishlist(),
      ]);
    if (
      !state?.succ ||
      !company?.succ ||
      !fuel?.succ ||
      !gear?.succ ||
      !city?.succ
    ) {
      Toast(false, "", "Something went wrong");
      return;
    }
    console.log("allwishlist", allWishlist);
    let ids = (allWishlist || [])?.map((d, i) => d?.carid);
    setAllWishlist(new Set(ids || []));
    setStates(state?.data?.Data || []);
    setCompanylist(company?.data?.Data || []);
    setFuelist(fuel?.data?.Data || []);
    setGearlist(gear?.data?.Data || []);
    setCities(city?.data?.Data || []);
    if (models?.succ) {
      // if company is selected
      setModeList(models?.data?.Data || []);
    }
  };
  useEffect(() => {
    fetchPromiseAll();
    let mount = true;
    if (!Userlogin()) {
      navigate("/Login");
      return;
    }
    localStorage.setItem("customerCarCount", carcount);
    if (mount && pageIndexContxt === 1) {
      fetchCars({ index: pageIndexContxt });
    } else {
      setLoading(false);
    }
    return () => {
      mount = false;
    };
  }, []);

  // ONCHNAGE HANDELRS
  const handleDropchange = ({ obj, name }) => {
    console.log("obj", obj);
    setSearchContxt((prevSearch) => ({
      ...prevSearch,
      [name]: obj,
    }));
  };
  const handleSlider = (values, name) => {
    console.log("values", values);

    setSearchContxt((prevInput) => ({
      ...prevInput,
      [name]: values,
    }));
  };
  const handleStatechange = async ({ obj, name }) => {
    setSearchContxt((prevSearch) => ({
      ...prevSearch,
      [name]: obj,
      city: null,
    }));
    let res = await fetchCity({ stateid: obj?.Value });
    if (!res?.succ) {
      Toast(false, "", res?.msg);
      return;
    }
    setCities(res?.data?.Data || []);
  };
  const handleCompanychange = async ({ obj, name }) => {
    setSearchContxt((prevSearch) => ({
      ...prevSearch,
      [name]: obj,
      modelid: null,
    }));
    let res = await fetchModel({ companyid: obj?.Value });
    if (!res?.succ) {
      Toast(false, "", res?.msg);
      return;
    }
    setModeList(res?.data?.Data || []);
  };
  const addRemoveWishlist = async (data) => {
    setLoading(true);
    const { carnumber, carid } = data || {};
    console.log("carid", carid);

    // actiondata(Add/Delete)
    let obj = {
      actiondata: allWishlists?.has(carid) ? "Delete" : "Add",
      carnumber,
      carid,
    };
    const res = await handlePostApiGF({
      url: "/api/DealerFavouriteVehicle/addfavouritecars",
      obj,
    });
    setLoading(false);
    Toast(
      res?.succ,
      res?.msg || "Successful",
      res?.msg || "Something went wrong",
    );

    let ids = (await fetchAllWishlist())?.map((d, i) => d?.carid);
    console.log("ids", ids);

    setAllWishlist(new Set(ids));
    console.log("res add remove wishlist", res);
  };

  return (
    <div>
      <Header />
      <div className="page-space text-center d-flex justify-content-between align-items-center">
        <h2 className="page-title text-center">Buy Car</h2>
        <Link
          to={`/customercarwishlists/${localStorage.getItem("Ca1itd")}`}
          className="d-flex align-items-center gap-2"
          style={{
            border: "1px solid red",
            borderRadius: "6px",
            padding: "5px 5px",
            color: "red",
            fontWeight: "500",
            fontSize: "16px",
          }}
        >
          <FaRegHeart size={20} color="red" />
          Saved Cars
        </Link>
      </div>

      <div className="page-space" style={{ marginBottom: "50px" }}>
        {/* in devlop */}
        <div className="home-filter p-2">
          <div className="home-filtergrid">
            <div>
              <label className="form-label">Select State</label>
              <Select
                value={searchContxt.state}
                onChange={(obj) => handleStatechange({ obj, name: "state" })}
                options={States}
                getOptionLabel={(option) => option.Text}
                getOptionValue={(option) => option.Value}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                isSearchable={true}
                className="form-select  redBr"
              ></Select>
            </div>
            <div>
              <label className="form-label">Select City</label>
              <Select
                placeholder="City"
                onChange={(obj) => handleDropchange({ obj, name: "city" })}
                value={searchContxt.city}
                options={Cities}
                getOptionLabel={(option) => option.Text}
                getOptionValue={(option) => option.Text}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                isSearchable={true}
                className="form-select redBr"
              ></Select>
            </div>
            <div>
              <label className="form-label">Select Company</label>
              <Select
                placeholder="Company"
                onChange={(obj) => handleCompanychange({ obj, name: "compid" })}
                value={searchContxt.compid}
                options={Companylist}
                getOptionLabel={(option) => option.Text}
                getOptionValue={(option) => option.Value}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                isSearchable={true}
                className="form-select redBr"
              ></Select>
            </div>
            <div>
              <label className="form-label">Select Model</label>
              <Select
                placeholder="Model"
                name="modelid"
                onChange={(obj) => handleDropchange({ obj, name: "modelid" })}
                value={searchContxt.modelid}
                options={ModeList}
                getOptionLabel={(option) => option.Text}
                getOptionValue={(option) => option.Value}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                isSearchable={true}
                isClearable={true}
                className="form-select redBr"
              ></Select>
            </div>
            <div>
              <label className="form-label">Select Fuel</label>
              <Select
                placeholder="Fuel"
                onChange={(obj) => handleDropchange({ obj, name: "fuel" })}
                value={searchContxt.fuel}
                options={Fuelist}
                getOptionLabel={(option) => option.Text}
                getOptionValue={(option) => option.Value}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                isSearchable={true}
                isClearable={true}
                className="form-select redBr"
              ></Select>
            </div>
            <div>
              <label className="form-label">Gear</label>
              <Select
                placeholder="Gear"
                onChange={(obj) => handleDropchange({ obj, name: "Gear" })}
                value={searchContxt.Gear}
                options={Gearlist}
                getOptionLabel={(option) => option.Text}
                getOptionValue={(option) => option.Value}
                closeMenuOnSelect={true}
                blurInputOnSelect={false}
                isSearchable={true}
                isClearable={true}
                className="form-select redBr"
              ></Select>
            </div>
          </div>
          <div className="mt10">
            <label className="form-label">Vehicle Owner</label>
            <Select
              placeholder="Vehicle Owner"
              onChange={(obj) => handleDropchange({ obj, name: "owner" })}
              value={searchContxt.owner}
              options={ownerlist}
              getOptionLabel={(option) => option.Text}
              getOptionValue={(option) => option.Value}
              closeMenuOnSelect={true}
              blurInputOnSelect={false}
              isSearchable={true}
              isClearable={true}
              className="form-select redBr"
            ></Select>
          </div>
          <div className="home-rangegrid pt-4">
            <div>
              <div className="d-flex justify-content-between">
                <label className="form-label" style={{ display: "block" }}>
                  Year
                </label>
                <label
                  className="form-label smletter"
                  style={{ display: "block" }}
                >
                  {searchContxt.ModelYear[0]}-{searchContxt.ModelYear[1]}
                </label>
              </div>
              <RangeSlider
                className="single-thumb"
                onInput={(value) => handleSlider(value, "ModelYear")}
                defaultValue={searchContxt.ModelYear}
                min={2003}
                max={new Date().getFullYear()}
                step={1}
              />
            </div>
            <div className="my-3">
              <div className="d-flex justify-content-between mb-3 ">
                <label className="form-label" style={{ display: "block" }}>
                  Budget
                </label>
                <div className="d-flex justify-content-center align-items-center gap-3">
                  <button
                    className="circle-redbtn"
                    onClick={() => {
                      if (searchContxt?.Pricerange[0] <= 0) return;
                      setSearchContxt((prev) => ({
                        ...prev,
                        Pricerange: [
                          searchContxt.Pricerange[0] - 50000,
                          searchContxt.Pricerange[1],
                        ],
                      }));
                    }}
                  >
                    -
                  </button>
                  <label className=" smletter" style={{ display: "block" }}>
                    {formatRupee({ amt: searchContxt.Pricerange[0] })} -{" "}
                    {formatRupee({ amt: searchContxt.Pricerange[1] })}
                    {searchContxt.Pricerange[1] >= 50000000 ? "+" : ""}
                  </label>
                  <button
                    className="circle-redbtn"
                    onClick={() => {
                      if (
                        searchContxt?.Pricerange[0] >=
                        searchContxt.Pricerange[1]
                      ) {
                        return;
                      }

                      setSearchContxt((prev) => ({
                        ...prev,
                        Pricerange: [
                          searchContxt.Pricerange[0] + 50000,
                          searchContxt.Pricerange[1],
                        ],
                      }));
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
              <RangeSlider
                className="single-thumb"
                onInput={(value) => handleSlider(value, "Pricerange")}
                value={searchContxt.Pricerange}
                // min={50000}
                min={0}
                max={50000000}
                step={50000}
              />
            </div>
            <div>
              <div className="d-flex justify-content-between">
                <label className="form-label" style={{ display: "block" }}>
                  Kms Driven
                </label>
                <label
                  className="form-label smletter"
                  style={{ display: "block" }}
                >
                  {formatRupee({
                    amt: searchContxt.KMange[0],
                    rupeeIcon: false,
                  })}{" "}
                  -{" "}
                  {formatRupee({
                    amt: searchContxt.KMange[1],
                    rupeeIcon: false,
                  })}
                  {searchContxt.KMange[1] === 500000 ? "+" : ""}
                </label>
              </div>
              <RangeSlider
                className="single-thumb"
                defaultValue={searchContxt.KMange}
                onInput={(value) => handleSlider(value, "KMange")}
                min={0}
                max={500000}
                step={5000}
              />
            </div>
          </div>
          <div className="mt-4">
            <label className="form-label">&nbsp;</label>
            <button
              type="submit"
              className="web-btn lightRedBtn"
              onClick={onSubmitSearch}
            >
              Search
            </button>
          </div>
        </div>

        {loading && <Loader />}
        {resultsContxt.length === 0 && !loading ? (
          <NoCars />
        ) : (
          resultsContxt.map((data, i) => (
            <div className="car-div mt-4" key={data.Rand}>
              <div className="car-radius">
                <div className="position-relative">
                  <img
                    src={allWishlists.has(data?.carid) ? redheart : blackheart}
                    style={{ position: "absolute", right: "10px", top: "10px" }}
                    alt=""
                    onClick={() => addRemoveWishlist(data)}
                  />
                  <img src={data.carphoto} className="w-100" alt="" />
                </div>
                <div className="car-smdetails">
                  <span className="abs-span">{data.fueltypeid}</span>
                  <RemainingPageTitle dataFromParent={data} />

                  <div className="car-km justify-content-start gap-2 flex-wrap">
                    <>
                      <div className="d-flex align-items-center">
                        <img src="assets/images/car-num.svg" alt="" />
                        <span>{data.carnumber}</span>
                      </div>
                      {data.km && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/car-km.svg"
                            alt=""
                            // className="ms-2"
                          />
                          <span>
                            {formatRupee({ amt: data.km, rupeeIcon: false })}
                          </span>
                        </div>
                      )}
                      {data.Carage && (
                        <div className="d-flex align-items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="21"
                            height="21"
                            viewBox="0 0 357.102 357.102"
                            // className="ms-2"
                          >
                            <g>
                              <path
                                d="M192.349 13.8c-90.484 0-164.387 73.614-164.741 164.096..."
                                fill="#ff002a"
                              ></path>
                              <path
                                d="M186.553 98.752c-8.284 0-15 6.716-15 15v63..."
                                fill="#ff002a"
                              ></path>
                            </g>
                          </svg>
                          <span>{data.Carage} days</span>
                        </div>
                      )}

                      {data.nCity && (
                        <div className="d-flex align-items-center">
                          <img
                            src="assets/images/address.png"
                            height={21}
                            width={21}
                            alt="address"
                            // className="ms-2"
                          />
                          <span>
                            {data.nCity}, {data.nState}
                          </span>
                        </div>
                      )}
                      {/* <div className="d-flex align-items-center">
                        <span className="material-symbols-outlined fs-2 p-0">
                          person
                        </span>
                        <span>{formateNumberStNdRd(data?.owner)} Owner</span>
                      </div> */}
                    </>
                  </div>
                </div>
                <div className="two-btns">
                  <Link
                    to={`/customercardetail/${data?.Rand}`}
                    state={{ details: data }}
                    className="w-100 lightRedBtn"
                    style={{ borderRadius: "0 0 10px 10px" }}
                  >
                    More Details
                  </Link>
                </div>
              </div>
            </div>
          ))
        )}

        <InfiniteScroll
          dataLength={resultsContxt.length}
          next={loadMoreCars}
          hasMore={hasMore}
          // loader={<Loader />}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
        />

        <ScrollButton />
      </div>
    </div>
  );
}

export default CustomerCarList;

// old wihtout wishlist

// import React, { useCallback, useEffect, useState } from "react";
// import {
//   Toast,
//   Userlogin,
//   formatRupee,
//   formateNumberStNdRd,
//   handleGetApiGF,
//   handlePostApiGF,
// } from "../Utils/general-function";
// import { useNavigate, Link, useLocation } from "react-router-dom";
// import Header from "../Header";
// import Loader from "../Utils/Loader";
// import Search from "../Search";
// import RemainingPageTitle from "../Utils/RemainingPageTitle";
// import NoCars from "../Utils/NoCars";
// import InfiniteScroll from "react-infinite-scroll-component";
// import ScrollButton from "../Utils/scrollbutton";
// import { useCustomerCarContext } from "../Contexts/CustomerCarListContext";

// // advance filter
// import Select from "react-select";
// import RangeSlider from "react-range-slider-input";
// import "react-range-slider-input/dist/style.css";
// import blackheart from "../../src_img/blackheart.png";
// import redheart from "../../src_img/redheart.png";
// function CustomerCarList() {
//   const navigate = useNavigate();
//   const [loading, setLoading] = useState(true);
//   const {
//     carState,
//     setCarState,
//     searchContxt,
//     setSearchContxt,
//     resultsContxt,
//     setResultsContxt,
//     pageIndexContxt,
//     setPageIndexContxt,
//     UserloggedContxt,
//     setUserloggedContxt,
//   } = useCustomerCarContext();

//   console.log(" useCustomerCarContext()", useCustomerCarContext());

//   const { originalList, showList, pageIndex, searchText } = carState;
//   // let { state.carcount: carCountFromParent } = useLocation();
//   let location = useLocation();
//   const { carcount } = location?.state || {}; // from parent to store in locla storage

//   // in devlop
//   const [Companylist, setCompanylist] = useState([]);
//   const [ModeList, setModeList] = useState([]);
//   const [States, setStates] = useState([]);
//   const [Cities, setCities] = useState([]);
//   // const [vehicletypes, setVehicletypes] = useState([]);
//   // const [errors, setErrors] = useState({});
//   const [Fuelist, setFuelist] = useState([]);
//   const [Gearlist, setGearlist] = useState([]);
//   const [hasMore, setHasMore] = useState(true);
//   const [ownerlist] = useState([
//     { Text: "1", Value: 1 },
//     { Text: "2", Value: 2 },
//     { Text: "3", Value: 3 },
//     { Text: "4", Value: 4 },
//     { Text: "5", Value: 5 },
//   ]);
//   const fetchCars = async ({ index = 1, isLoadMore = false }) => {
//     try {
//       setLoading(true);
//       setHasMore(true);

//       // setCarState((prev) => ({ ...prev, hasMore: true }));
//       const {
//         state,
//         city,
//         compid,
//         modelid,
//         fuel,
//         ModelYear,
//         Pricerange,
//         KMange,
//         vehicle,
//         Gear,
//         owner,
//       } = searchContxt;
//       // const { pageIndex } = carState;
//       let obj = {
//         nState: state?.Text || null,
//         nCity: city?.Text || "",
//         companyid: compid?.Value || "",
//         carmodelid: modelid?.Value || "",
//         lowerprice: Pricerange[0],
//         upperprice: Pricerange[1],
//         kmbelow: KMange[0],
//         kmupper: KMange[1],
//         modelyearstart: ModelYear[0],
//         modelyear: ModelYear[1],
//         fueltypeid: fuel?.Value || "",
//         pageindex: index,
//         Gearid: Gear?.Value || "",
//         vehicleid: "",
//         owner: owner?.Value || "",
//       };
//       const res = await handlePostApiGF({
//         url: `/api/CarthiClientSellInquiry/CarthiClientSellcarlist1`,
//         obj,
//       });

//       if (!res?.succ) {
//         if (res?.msg === "Data not available") {
//           // setCarState((prev) => ({ ...prev, hasMore: false }));
//           if (!isLoadMore) {
//             // on search btn etc no data then clear previous data
//             setResultsContxt([]);
//           }
//           setHasMore(false);
//           // setCarState((prev) => ({ ...prev, hasMore: false }));
//         } else {
//           Toast(false, "", res?.msg);
//         }
//         setLoading(false);
//         return;
//       }

//       const newData = res.data?.Data || [];
//       console.log("newData", newData);

//       if (isLoadMore) {
//         setResultsContxt([...resultsContxt, ...newData]);
//       } else {
//         window.scrollTo({ top: 0, behavior: "smooth" });

//         setResultsContxt(newData || []);
//       }
//       setLoading(false);
//     } catch (error) {
//       console.log("Exception found", error);
//       setLoading(false);
//       // setCarState((prev) => ({ ...prev, hasMore: false }));
//       setHasMore(false);
//     }
//   };

//   const loadMoreCars = () => {
//     const nextIndex = pageIndexContxt + 1;
//     console.log("called LoadMore");

//     // setCarState((prev) => ({ ...prev, pageIndex: nextIndex }));
//     setPageIndexContxt((prev) => nextIndex);
//     fetchCars({ index: nextIndex, isLoadMore: true });
//   };
//   const onSubmitSearch = () => {
//     const nextIndex = 1;
//     // setCarState((prev) => ({ ...prev, pageIndex: nextIndex }));
//     setPageIndexContxt(nextIndex);

//     fetchCars({ index: nextIndex });
//   };

//   const fetchState = () => {
//     const res = handleGetApiGF({
//       url: "/api/Common/statenamedata?countryid=1",
//     });
//     return res;
//   };

//   const fetchCompany = () => {
//     const res = handleGetApiGF({
//       url: "/api/Common/companydata",
//     });
//     return res;
//   };
//   const fetchFuel = () => {
//     const res = handleGetApiGF({
//       url: "/api/Common/Fueldata",
//     });
//     return res;
//   };
//   const fetchGear = () => {
//     const res = handleGetApiGF({
//       url: "/api/Common/Geardata",
//     });
//     return res;
//   };
//   const fetchCity = ({ stateid }) => {
//     const res = handleGetApiGF({
//       url: "/api/Common/citynamedata?countryid=1&stateid=" + stateid,
//     });
//     return res;
//   };
//   const fetchModel = ({ companyid }) => {
//     const res = handleGetApiGF({
//       url: "/api/Common/activemodel/" + companyid,
//     });
//     return res;
//   };

//   const fetchPromiseAll = async () => {
//     const [state, company, fuel, gear, city, models] = await Promise.all([
//       fetchState(),
//       fetchCompany(),
//       fetchFuel(),
//       fetchGear(),
//       fetchCity({ stateid: searchContxt?.state?.Value }),
//       searchContxt?.compid?.Value &&
//         fetchModel({ companyid: searchContxt?.compid?.Value }),
//     ]);
//     if (
//       !state?.succ ||
//       !company?.succ ||
//       !fuel?.succ ||
//       !gear?.succ ||
//       !city?.succ
//     ) {
//       Toast(false, "", "Something went wrong");
//       return;
//     }
//     setStates(state?.data?.Data || []);
//     setCompanylist(company?.data?.Data || []);
//     setFuelist(fuel?.data?.Data || []);
//     setGearlist(gear?.data?.Data || []);
//     setCities(city?.data?.Data || []);
//     if (models?.succ) {
//       // if company is selected
//       setModeList(models?.data?.Data || []);
//     }
//     // console.log("state api", state);
//     // console.log("company api", company);
//     // console.log("fuel api", fuel);
//     // console.log("gear api", gear);
//     // console.log("city api", city);
//     // console.log("models", models);
//   };
//   useEffect(() => {
//     fetchPromiseAll();
//     let mount = true;
//     if (!Userlogin()) {
//       navigate("/Login");
//       return;
//     }
//     localStorage.setItem("customerCarCount", carcount);
//     if (mount && pageIndexContxt === 1) {
//       fetchCars({ index: pageIndexContxt });
//     } else {
//       setLoading(false);
//     }
//     return () => {
//       mount = false;
//     };
//   }, []);

//   const handleSearchCallback = useCallback(
//     ({ list, searchText }) => {
//       setCarState((prev) => {
//         if (
//           prev.searchText === searchText &&
//           JSON.stringify(prev.showList) === JSON.stringify(list)
//         ) {
//           return prev; // no update needed
//         }
//         return {
//           ...prev,
//           showList: list || [],
//           searchText,
//         };
//       });
//     },
//     [setCarState],
//   );

//   // ONCHNAGE HANDELRS
//   const handleDropchange = ({ obj, name }) => {
//     console.log("obj", obj);
//     setSearchContxt((prevSearch) => ({
//       ...prevSearch,
//       [name]: obj,
//     }));
//   };
//   const handleSlider = (values, name) => {
//     console.log("values", values);

//     setSearchContxt((prevInput) => ({
//       ...prevInput,
//       [name]: values,
//     }));
//   };
//   const handleStatechange = async ({ obj, name }) => {
//     setSearchContxt((prevSearch) => ({
//       ...prevSearch,
//       [name]: obj,
//       city: null,
//     }));
//     let res = await fetchCity({ stateid: obj?.Value });
//     if (!res?.succ) {
//       Toast(false, "", res?.msg);
//       return;
//     }
//     console.log("res city", res);
//     setCities(res?.data?.Data || []);
//   };
//   const handleCompanychange = async ({ obj, name }) => {
//     setSearchContxt((prevSearch) => ({
//       ...prevSearch,
//       [name]: obj,
//       modelid: null,
//     }));
//     let res = await fetchModel({ companyid: obj?.Value });
//     if (!res?.succ) {
//       Toast(false, "", res?.msg);
//       return;
//     }
//     console.log("res Model", res);
//     setModeList(res?.data?.Data || []);
//   };

//   return (
//     <div>
//       <Header />
//       <div className="text-center">
//         <h2 className="page-title">Buy Car</h2>
//       </div>

//       <div className="page-space" style={{ marginBottom: "50px" }}>
//         {/* in devlop */}
//         <div className="home-filter p-2">
//           <div className="home-filtergrid">
//             <div>
//               <label className="form-label">Select State</label>
//               <Select
//                 value={searchContxt.state}
//                 onChange={(obj) => handleStatechange({ obj, name: "state" })}
//                 options={States}
//                 getOptionLabel={(option) => option.Text}
//                 getOptionValue={(option) => option.Value}
//                 closeMenuOnSelect={true}
//                 blurInputOnSelect={false}
//                 isSearchable={true}
//                 className="form-select  redBr"
//               ></Select>
//             </div>
//             <div>
//               <label className="form-label">Select City</label>
//               <Select
//                 placeholder="City"
//                 onChange={(obj) => handleDropchange({ obj, name: "city" })}
//                 value={searchContxt.city}
//                 options={Cities}
//                 getOptionLabel={(option) => option.Text}
//                 getOptionValue={(option) => option.Text}
//                 closeMenuOnSelect={true}
//                 blurInputOnSelect={false}
//                 isSearchable={true}
//                 className="form-select redBr"
//               ></Select>
//             </div>
//             <div>
//               <label className="form-label">Select Company</label>
//               <Select
//                 placeholder="Company"
//                 onChange={(obj) => handleCompanychange({ obj, name: "compid" })}
//                 value={searchContxt.compid}
//                 options={Companylist}
//                 getOptionLabel={(option) => option.Text}
//                 getOptionValue={(option) => option.Value}
//                 closeMenuOnSelect={true}
//                 blurInputOnSelect={false}
//                 isSearchable={true}
//                 className="form-select redBr"
//               ></Select>
//             </div>
//             <div>
//               <label className="form-label">Select Model</label>
//               <Select
//                 placeholder="Model"
//                 name="modelid"
//                 onChange={(obj) => handleDropchange({ obj, name: "modelid" })}
//                 value={searchContxt.modelid}
//                 options={ModeList}
//                 getOptionLabel={(option) => option.Text}
//                 getOptionValue={(option) => option.Value}
//                 closeMenuOnSelect={true}
//                 blurInputOnSelect={false}
//                 isSearchable={true}
//                 isClearable={true}
//                 className="form-select redBr"
//               ></Select>
//             </div>
//             <div>
//               <label className="form-label">Select Fuel</label>
//               <Select
//                 placeholder="Fuel"
//                 onChange={(obj) => handleDropchange({ obj, name: "fuel" })}
//                 value={searchContxt.fuel}
//                 options={Fuelist}
//                 getOptionLabel={(option) => option.Text}
//                 getOptionValue={(option) => option.Value}
//                 closeMenuOnSelect={true}
//                 blurInputOnSelect={false}
//                 isSearchable={true}
//                 isClearable={true}
//                 className="form-select redBr"
//               ></Select>
//             </div>
//             <div>
//               <label className="form-label">Gear</label>
//               <Select
//                 placeholder="Gear"
//                 onChange={(obj) => handleDropchange({ obj, name: "Gear" })}
//                 value={searchContxt.Gear}
//                 options={Gearlist}
//                 getOptionLabel={(option) => option.Text}
//                 getOptionValue={(option) => option.Value}
//                 closeMenuOnSelect={true}
//                 blurInputOnSelect={false}
//                 isSearchable={true}
//                 isClearable={true}
//                 className="form-select redBr"
//               ></Select>
//             </div>
//           </div>
//           <div className="mt10">
//             <label className="form-label">Vehicle Owner</label>
//             <Select
//               placeholder="Vehicle Owner"
//               onChange={(obj) => handleDropchange({ obj, name: "owner" })}
//               value={searchContxt.owner}
//               options={ownerlist}
//               getOptionLabel={(option) => option.Text}
//               getOptionValue={(option) => option.Value}
//               closeMenuOnSelect={true}
//               blurInputOnSelect={false}
//               isSearchable={true}
//               isClearable={true}
//               className="form-select redBr"
//             ></Select>
//           </div>
//           <div className="home-rangegrid pt-4">
//             <div>
//               <div className="d-flex justify-content-between">
//                 <label className="form-label" style={{ display: "block" }}>
//                   Year
//                 </label>
//                 <label
//                   className="form-label smletter"
//                   style={{ display: "block" }}
//                 >
//                   {searchContxt.ModelYear[0]}-{searchContxt.ModelYear[1]}
//                 </label>
//               </div>
//               <RangeSlider
//                 className="single-thumb"
//                 onInput={(value) => handleSlider(value, "ModelYear")}
//                 defaultValue={searchContxt.ModelYear}
//                 min={2003}
//                 max={new Date().getFullYear()}
//                 step={1}
//               />
//             </div>
//             <div className="my-3">
//               <div className="d-flex justify-content-between mb-3 ">
//                 <label className="form-label" style={{ display: "block" }}>
//                   Budget
//                 </label>
//                 <div className="d-flex justify-content-center align-items-center gap-3">
//                   <button
//                     className="circle-redbtn"
//                     onClick={() => {
//                       if (searchContxt?.Pricerange[0] <= 0) return;
//                       setSearchContxt((prev) => ({
//                         ...prev,
//                         Pricerange: [
//                           searchContxt.Pricerange[0] - 50000,
//                           searchContxt.Pricerange[1],
//                         ],
//                       }));
//                     }}
//                   >
//                     -
//                   </button>
//                   <label className=" smletter" style={{ display: "block" }}>
//                     {formatRupee({ amt: searchContxt.Pricerange[0] })} -{" "}
//                     {formatRupee({ amt: searchContxt.Pricerange[1] })}
//                     {searchContxt.Pricerange[1] >= 50000000 ? "+" : ""}
//                   </label>
//                   <button
//                     className="circle-redbtn"
//                     onClick={() => {
//                       if (
//                         searchContxt?.Pricerange[0] >=
//                         searchContxt.Pricerange[1]
//                       ) {
//                         return;
//                       }

//                       setSearchContxt((prev) => ({
//                         ...prev,
//                         Pricerange: [
//                           searchContxt.Pricerange[0] + 50000,
//                           searchContxt.Pricerange[1],
//                         ],
//                       }));
//                     }}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//               <RangeSlider
//                 className="single-thumb"
//                 onInput={(value) => handleSlider(value, "Pricerange")}
//                 value={searchContxt.Pricerange}
//                 // min={50000}
//                 min={0}
//                 max={50000000}
//                 step={50000}
//               />
//             </div>
//             <div>
//               <div className="d-flex justify-content-between">
//                 <label className="form-label" style={{ display: "block" }}>
//                   Kms Driven
//                 </label>
//                 <label
//                   className="form-label smletter"
//                   style={{ display: "block" }}
//                 >
//                   {formatRupee({
//                     amt: searchContxt.KMange[0],
//                     rupeeIcon: false,
//                   })}{" "}
//                   -{" "}
//                   {formatRupee({
//                     amt: searchContxt.KMange[1],
//                     rupeeIcon: false,
//                   })}
//                   {searchContxt.KMange[1] === 500000 ? "+" : ""}
//                 </label>
//               </div>
//               <RangeSlider
//                 className="single-thumb"
//                 defaultValue={searchContxt.KMange}
//                 onInput={(value) => handleSlider(value, "KMange")}
//                 min={0}
//                 max={500000}
//                 step={5000}
//               />
//             </div>
//           </div>
//           <div className="mt-4">
//             <label className="form-label">&nbsp;</label>
//             <button
//               type="submit"
//               className="web-btn lightRedBtn"
//               onClick={onSubmitSearch}
//             >
//               Search
//             </button>
//           </div>
//         </div>
//         {/* in devlop end */}
//         {/* <SearchDynamic
//           originalList={originalList}
//           parentCallback={handleSearchCallback}
//           searchText={searchText}
//         /> */}

//         {/* <Search
//           dataFromParent={originalList}
//           parentCallback={handleSearchCallback}
//         /> */}
//         {loading && <Loader />}
//         {resultsContxt.length === 0 && !loading ? (
//           <NoCars />
//         ) : (
//           resultsContxt.map((data, i) => (
//             <div className="car-div mt-4" key={data.Rand}>
//               <div className="car-radius">
//                 <div className="position-relative">
//                   {/* <img
//                     src={i % 2 === 0 ? redheart : blackheart}
//                     style={{ position: "absolute", right: "10px", top: "10px" }}
//                     alt=""
//                   /> */}
//                   <img src={data.carphoto} className="w-100" alt="" />
//                 </div>
//                 <div className="car-smdetails">
//                   <span className="abs-span">{data.fueltypeid}</span>
//                   <RemainingPageTitle dataFromParent={data} />

//                   <div className="car-km justify-content-start gap-2 flex-wrap">
//                     <>
//                       <div className="d-flex align-items-center">
//                         <img src="assets/images/car-num.svg" alt="" />
//                         <span>{data.carnumber}</span>
//                       </div>
//                       {data.km && (
//                         <div className="d-flex align-items-center">
//                           <img
//                             src="assets/images/car-km.svg"
//                             alt=""
//                             // className="ms-2"
//                           />
//                           <span>
//                             {formatRupee({ amt: data.km, rupeeIcon: false })}
//                           </span>
//                         </div>
//                       )}
//                       {data.Carage && (
//                         <div className="d-flex align-items-center">
//                           <svg
//                             xmlns="http://www.w3.org/2000/svg"
//                             width="21"
//                             height="21"
//                             viewBox="0 0 357.102 357.102"
//                             // className="ms-2"
//                           >
//                             <g>
//                               <path
//                                 d="M192.349 13.8c-90.484 0-164.387 73.614-164.741 164.096..."
//                                 fill="#ff002a"
//                               ></path>
//                               <path
//                                 d="M186.553 98.752c-8.284 0-15 6.716-15 15v63..."
//                                 fill="#ff002a"
//                               ></path>
//                             </g>
//                           </svg>
//                           <span>{data.Carage} days</span>
//                         </div>
//                       )}

//                       {data.nCity && (
//                         <div className="d-flex align-items-center">
//                           <img
//                             src="assets/images/address.png"
//                             height={21}
//                             width={21}
//                             alt="address"
//                             // className="ms-2"
//                           />
//                           <span>
//                             {data.nCity}, {data.nState}
//                           </span>
//                         </div>
//                       )}
//                       {/* <div className="d-flex align-items-center">
//                         <span className="material-symbols-outlined fs-2 p-0">
//                           person
//                         </span>
//                         <span>{formateNumberStNdRd(data?.owner)} Owner</span>
//                       </div> */}
//                     </>
//                   </div>
//                 </div>
//                 <div className="two-btns">
//                   <Link
//                     to={`/customercardetail/${data?.Rand}`}
//                     state={{ details: data }}
//                     className="w-100 lightRedBtn"
//                     style={{ borderRadius: "0 0 10px 10px" }}
//                   >
//                     More Details
//                   </Link>
//                 </div>
//               </div>
//             </div>
//           ))
//         )}

//         <InfiniteScroll
//           dataLength={resultsContxt.length}
//           next={loadMoreCars}
//           hasMore={hasMore}
//           // loader={<Loader />}
//           endMessage={
//             <p style={{ textAlign: "center" }}>
//               <b>Yay! You have seen it all</b>
//             </p>
//           }
//         />

//         <ScrollButton />
//       </div>
//     </div>
//   );
// }

// export default CustomerCarList;
